import React, { useEffect, useState } from 'react';
import styles from './SuccessfulAccountCreationModal.module.scss';

const DEFAULT_TIME_LEFT = 5;

function SuccessfulAccountCreationModal(props: {
  onTimeOut: () => void;
}) {
  const { onTimeOut } = props;
  const [timeLeft, setTimeLeft] = useState(DEFAULT_TIME_LEFT);
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
      if (timeLeft <= 0) {
        onTimeOut();
      }
    }, 1000);

    return () => clearTimeout(timer);
  });

  const calculateTimeBarFillWidth = () => 100
    * ((DEFAULT_TIME_LEFT - timeLeft) / DEFAULT_TIME_LEFT);

  return (
    <>
      <section className="av">
        <div className="av__overlay" />
        <div className={`av__body ${styles.container}`}>
          <h1 className={styles.title}>Success!</h1>
          <div className={styles.subtitle}>
            You’ll be automatically redirected to the sale page in a moment.
          </div>
          <i className={`${styles.check} fal fa-check-circle`} />
          <div className={styles.timerBar}>
            <span className={styles.timeBarText}>
              GO TO SALE PAGE IN
              {` ${timeLeft}`}
            </span>
            <span className={styles.timeBarFill} style={{ width: `${calculateTimeBarFillWidth()}%` }} />
          </div>
        </div>
      </section>
    </>
  );
}

export default SuccessfulAccountCreationModal;
